module.exports = __webpack_public_path__ + "static/media/lemon.be962e74.svg";